var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.appUser)?_c('v-app',{staticStyle:{"background-color":"white"}},[_c('ObservationReport')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }